// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/styles/crs.scss
// module id = 721
// module chunks = 0